import React, { useState, useEffect } from "react";
import Adminsidebar from "../components/Adminsidebar";
import Adminheader from "../components/Adminheader";
import Uppercase from "../components/Uppercase";
import { useParams, Link,useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2"; // Import SweetAlert

function EditEmployee() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { empId } = useParams(); // Retrieve the employee ID from the route
  const [employeeData, setEmployeeData] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // Initialize navigate function

  
  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      try {
        const response = await axios.get(
          `https://api.litaxfilers.com/api/getdetailsemployee/${empId}`
        );
        
        setEmployeeData(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching employee data:", error);
        setLoading(false);
      }
    };

    fetchEmployeeDetails();
  }, [empId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEmployeeData({ ...employeeData, [name]: value });
  };
  const handleUpdateEmployee = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.put(
        `https://api.litaxfilers.com/api/updateemployee/${empId}`,
        employeeData
      );

      if (response.status === 200) {
        // Display SweetAlert on success
        Swal.fire({
          title: "Success!",
          text: "Employee updated successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          // Navigate to /employeeinformation
          navigate("/employeinformation");
        });
      } else {
        // Display SweetAlert on failure
        Swal.fire({
          title: "Error!",
          text: "Failed to update the employee.",
          icon: "error",
          confirmButtonText: "Try Again",
        });
      }
    } catch (error) {
      console.error("Error updating employee:", error);
      // Display SweetAlert for exception
      Swal.fire({
        title: "Error!",
        text: "An error occurred while updating the employee.",
        icon: "error",
        confirmButtonText: "Try Again",
      });
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Adminheader openSidebar={openSidebar} />
        <Adminsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
            {/* Edit Employee Form */}
            <div className="mt-3">
              <h3>Edit Employee</h3>
              <form onSubmit={handleUpdateEmployee}>
                <div className="form-group mb-2">
                  <label>Username</label>
                  <input
                    type="text"
                    className="form-control"
                    name="username"
                    value={employeeData.username || ""}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group mb-2">
                  <label>Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={employeeData.email || ""}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group mb-2">
                  <label>Work Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="workEmail"
                    value={employeeData.workEmail || ""}
                    onChange={handleInputChange}
                  />
                </div>
              
                <div className="form-group mb-2">
                  <label>Contact</label>
                  <input
                    type="text"
                    className="form-control"
                    name="phoneNumber"
                    value={employeeData.phoneNumber || ""}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group mb-2">
                  <label>Role</label>
                  <select
                   type="text"
                    className="form-control"
                    name="role"
                    value={employeeData.role || ""}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Role</option>
                    <option value="Jr CRE">Client Relationship Executive</option>
                    <option value="Sr CRE">
                      Senior Client Relationship Executive
                    </option>
                    <option value="Team Lead">Team Lead</option>
                    <option value="Jr Preparer">Preparer</option>
                    <option value="Sr Preparer">Senior Preparer</option>
                    <option value="Jr Reviewer">Reviewer</option>
                    <option value="Sr Reviewer">Senior Reviewer</option>
                    <option value="Marketing Manager">
                      Marketing Manager
                    </option>
                    <option value="Social Media Manager">
                      Social Media Manager
                    </option>
                    <option value="Sales Manager">Sales Manager</option>
                    <option value="Sales Development Representative">
                      Sales Development Representative
                    </option>
                    <option value="HR Manager">HR Manager</option>
                  </select>
                </div>
                <div className="form-group mb-2">
                  <label>Department</label>
                  <select
                    className="form-control"
                    name="department"
                    value={employeeData.department || ""}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Department</option>
                    <option value="Taxation">Taxation</option>
                    <option value="Marketing">Marketing</option>
                    <option value="Sales">Sales</option>
                    <option value="HR">HR</option>
                  </select>
                </div>
                <div className="form-group mb-2">
                  <label>Target Assigned</label>
                  <input
                    type="number"
                    className="form-control"
                    name="targetAssigned"
                    placeholder="Ex: $ 10000"
                    value={employeeData.targetAssigned || ""}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group mb-2">
                  <label>Date Hired</label>
                  <input
                    type="date"
                    className="form-control"
                    name="dateHired"
                    value={employeeData.dateHired || ""}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group mb-2">
                  <label>Status</label>
                  <select
                    className="form-control"
                    name="status"
                    value={employeeData.status || ""}
                    onChange={handleInputChange}
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
                <button type="submit" className="btn btn-primary mt-1">
                  Update Employee
                </button>
              </form>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default EditEmployee;
